import {MessageView} from "./components/MessageView";

export const LoadingMessageView = () => (
  <MessageView message="載入中..." />
)